// import React, { Component } from "react";
import React, { useEffect, useState, useRef } from "react";
import { Table } from "antd";
import qs from "qs";
import { useSelector, useDispatch } from "react-redux";
import closeRed from "../../../../../../images/branching/close-red.svg";
import settingIconFx from "../../../../../../images/training/settings-icon.png";

import logsIconFx from "../../../../../../images/training/logs-icon.png";

import { getAutomationBuildLogs } from "../../../../../../redux/actions/logs";
import moment from "moment";
import CopyToClipboard from "react-copy-to-clipboard";
import { Space, Tag, Button, Tooltip, Divider, Input, DatePicker } from "antd";
import Highlighter from "react-highlight-words";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  DownloadOutlined,
  CopyOutlined,
  LoadingOutlined,
  ReloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Excel } from "antd-table-saveas-excel";
import { notify } from "../../../../../../redux/actions/snack";

const BottomBar = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateFilter, setDateFilter] = useState(false);

  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (skillId) => {
    dispatch(getAutomationBuildLogs(skillId, searchText));
    setTableParams((prevTableParams) => ({
      ...prevTableParams,
      text: searchText,
    }));
  };
  const handleReset = (clearFilters) => {
    setSearchText("");
    setTableParams((prevTableParams) => ({
      ...prevTableParams,
      text: "",
    }));
    clearFilters();
  };

  const handleDateReset = (confirm) => {
    setStartDate("");
    setEndDate("");
    setDateFilter(true);
    confirm();
  };
  useEffect(() => {
    fetchData();
    setDateFilter(false);
  }, [dateFilter]);

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      position: ["bottomCenter"],
    },
    text: "",
  });

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onPressEnter={() => {
            setTableParams((prevTableParams) => ({
              ...prevTableParams,
              text: searchText,
            }));

            handleSearch(skill?.id);
          }}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(skill.id)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button> */}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          fontSize: "16px",
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      let val = false;
      dataIndex.forEach((i) => {
        if (typeof record[i] == "string") {
          val =
            val ||
            record[i]
              .toString()
              .toLowerCase()
              .includes(value.trim().toLowerCase());
        } else if (typeof record[i] == "object" && record[i]) {
          val =
            val ||
            JSON.stringify(record[i])
              .toLowerCase()
              .includes(value.trim().toLowerCase());
        }
      });
      return val;
    },

    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const selectStartDate = (dateValue) => {
    const dateText = moment(dateValue).format("YYYY-MM-DD");
    setStartDate(dateText);
  };
  const selectEndDate = (dateValue) => {
    const dateText = moment(dateValue).format("YYYY-MM-DD");
    setEndDate(dateText);
  };

  const columns = [
    {
      title: "Instance ID",
      dataIndex: "uuid",
      key: "uuid",
      // render: (text) => <div style={{ fontWeight: 300 }}>{text} </div>,
      width: "30%",
      ...getColumnSearchProps(["uuid", "meta_data"]),
    },

    {
      title: (
        <Space align="end">
          Status
          <Button
            size={"small"}
            type="primary"
            className="ant-btn-refresh"
            style={{ borderRadius: 3, fontSize: 10 }}
            loading={loading}
            icon={<ReloadOutlined />}
            onClick={() => fetchData()}
          ></Button>
        </Space>
      ),
      dataIndex: "status",
      key: "status",
      // width: "10%",
      render: (tag) => {
        let color = "#1d262e";
        let icon = null;
        if (tag === "errored") {
          color = "red";
          icon = <CloseCircleOutlined />;
        } else if (tag === "completed") {
          color = "green";
          icon = <CheckCircleOutlined />;
        } else if (tag === "started") {
          color = "geekblue";
          icon = <SyncOutlined spin />;
        }
        return (
          <Tag
            color={color}
            key={tag}
            icon={icon}
            style={{ borderRadius: 3, fontSize: 11 }}
          >
            {tag.toUpperCase()}
          </Tag>
        );
      },
      filters: [
        {
          text: "errored",
          value: "errored",
        },
        {
          text: "completed",
          value: "completed",
        },
        {
          text: "started",
          value: "started",
        },
        {
          text: "stopped",
          value: "stopped",
        },
      ],
      onFilter: (value, record) => record.status.startsWith(value),
      filterSearch: true,
      // width: '40%',
    },
    {
      title: (
        <Space direction="vertical" size={5}>
          Created At
        </Space>
      ),
      dataIndex: "created_at",
      key: "created_at",
      width: "30%",
      filterDropdown: ({ confirm, close }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <div style={{ marginBottom: "10px" }}>
            <Space>
              <DatePicker
                allowClear={false}
                value={startDate ? moment(startDate, "YYYY-MM-DD") : null}
                placeholder="Start date"
                onChange={(date) => selectStartDate(date)}
              />
              <DatePicker
                allowClear={false}
                value={endDate ? moment(endDate, "YYYY-MM-DD") : null}
                placeholder="End date"
                onChange={(date) => selectEndDate(date)}
              />
            </Space>
          </div>
          <Space>
            <Button
              className="btn-primary"
              type="primary"
              onClick={() => {
                if (moment(startDate).isValid() && moment(endDate).isValid()) {
                  setTableParams({
                    ...tableParams,
                    pagination: {
                      current: 1,
                      pageSize: 10,
                      position: ["bottomCenter"],
                    },
                  });
                  fetchData();
                  confirm();
                } else {
                  dispatch(
                    notify("error", "Please enter both start and end dates")
                  );
                }
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
                "border-radius": "3px",
                padding: "3px",
                height: "initial",
              }}
            >
              Search
            </Button>
            <Button
              class="ant-btn ant-btn-default ant-btn-sm"
              onClick={() => {
                handleDateReset(confirm);
              }}
              size="small"
              style={{
                width: "90px",
                border: "1px solid #02ce9d",
                color: "#02ce9d",
                "border-radius": "3px",
                padding: "3px",
                height: "initial",
              }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
              style={{
                color: "#ff3333",
              }}
            >
              Close
            </Button>
          </Space>
        </div>
      ),
      render: (date) => moment(date).format("YYYY-MM-DD, h:mm:ss a"),
    },

    {
      title: (
        <Space align="end" split={<Divider type="vertical" />}>
          Action
          <Button
            size={"small"}
            type="primary"
            className="ant-btn-refresh"
            style={{ borderRadius: 3, fontSize: 10 }}
            onClick={() => handleClick()}
          >
            Export
          </Button>
        </Space>
      ),
      key: "action",
      width: "20%",
      render: (_, record, index) => {
        {
          if (record.status == "started") {
            return (
              <Tooltip
                placement="top"
                title={"No log preview available"}
                color="#141414"
                overlayStyle={{ borderRadius: 3 }}
              >
                <Button
                  disabled={true}
                  type="primary"
                  icon={<DownloadOutlined color={"#1d262e"} />}
                  size={"small"}
                />
              </Tooltip>
            );
          } else {
            return (
              <Space size="middle">
                {userDetails.role_id == "2" ||
                currentUser.user_id == record.user_id ? (
                  <Tooltip
                    placement="top"
                    title={"Download logs"}
                    color="#141414"
                    overlayStyle={{ borderRadius: 3 }}
                  >
                    <Button
                      icon={<DownloadOutlined style={{ color: "#fff" }} />}
                      size={"small"}
                      target="_blank"
                      style={{ backgroundColor: "#1d262e" }}
                      href={`${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/automation/logs/${record.uuid}.txt`}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip
                    placement="top"
                    title={"Insufficient privileges"}
                    color="#141414"
                    overlayStyle={{ borderRadius: 3 }}
                  >
                    <Button
                      icon={<DownloadOutlined style={{ color: "#fff" }} />}
                      size={"small"}
                      target="_blank"
                      style={{ backgroundColor: "#1d262e" }}
                      disabled={true}
                    />
                  </Tooltip>
                )}
                {index == 0 ? (
                  <Tooltip
                    placement="top"
                    title={"Copy Log Path"}
                    color="#141414"
                    overlayStyle={{ borderRadius: 3 }}
                  >
                    <CopyToClipboard text={logPath}>
                      <Button
                        type="default"
                        icon={<CopyOutlined color={"#1d262e"} />}
                        size={"small"}
                      />
                    </CopyToClipboard>
                  </Tooltip>
                ) : null}
              </Space>
            );
          }
        }
      },
    },
  ];

  const headerColumns = [
    {
      title: "Instance ID",
      dataIndex: "uuid",
      key: "uuid",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Meta data",
      dataIndex: "meta_data",
      key: "meta_data",
      excelRender: (metaData) => JSON.stringify(metaData, 2, 2),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      excelRender: (date) => moment(date).format("YYYY-MM-DD, h:mm:ss a"),
    },
  ];

  const handleClick = () => {
    const excel = new Excel();
    excel
      .addSheet("Sheet1")
      .addColumns(headerColumns)
      .addDataSource(data, {
        str2Percent: true,
      })
      .saveAs(`Audit-Trail-Skill-${skill.id}.xlsx`);
  };
  const skill = useSelector((state) => state?.skillReducer?.trainDraft);
  const logData = useSelector((state) => state.logsReducer);
  const logPath = `%temp%/${skill?.id}`;

  const userDetails = useSelector(
    (state) => state.organizationReducer.currentOrganization
  );
  const currentUser = useSelector(
    (state) => state.organizationReducer.currentOrgUser
  );

  const fetchData = (source) => {
    setLoading(true);
    if (skill?.id) {
        dispatch(
      getAutomationBuildLogs(skill.id, {
        page: tableParams.pagination.current,
        pageSize: tableParams.pagination.pageSize,
        filters: tableParams.filters,
        text: tableParams.text,
        startDate: moment(startDate, "YYYY-MM-DD HH:mm:ss")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(endDate, "YYYY-MM-DD HH:mm:ss")
          .utc()
          .add(1, "days")
          .format("YYYY-MM-DD HH:mm:ss"),
      })
    );
    }
  
  };

  useEffect(() => {
    fetchData();
  }, [skill?.id]);

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(tableParams)]);

  useEffect(() => {
    setLoading(false);
    setData(logData?.automationBuildLogs || []);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: logData?.total || 10,
      },
    });
  }, [logData]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  return (
    <div>
      {skill?.TEMPLATE === "UserDocumentation" ? null : (
        <div className="bd-outer">
          <a
            className="fxd-icon audit-trail-icon"
            data-toggle="tab"
            href="#c"
            onClick={(e) => {
              setShowLogs(true);
              fetchData();
            }}
          >
            <Tooltip title="Audit Trail">
              <img src={logsIconFx} />
            </Tooltip>
          </a>

          <div className="tab-content">
            <div id="a" className="tab-pane fade in active"></div>
            <div id="b" className="tab-pane fade in active"></div>
            <div id="c" className="tab-pane fade in active"></div>
          </div>
        </div>
      )}
      {showLogs ? (
        <div className="logs-view">
          <div
            className="prt-close"
            onClick={() => {
              setShowLogs(false);
            }}
          >
            <img src={closeRed} alt="" />
          </div>
          <Table
            scroll={{ y: 350 }}
            columns={columns}
            rowKey={(record) => record.uuid}
            dataSource={data}
            pagination={tableParams.pagination}
            loading={loading}
            onChange={handleTableChange}
            expandable={{
              expandedRowRender: (record) => (
                <div style={{}}>
                  <p
                    style={{
                      fontFamily: "inherit",
                      color: "#252525",
                      fontWeight: 300,
                    }}
                  >
                    {" "}
                    JSON parameters passed for automation
                  </p>
                  <pre
                    style={{
                      padding: "5px 15px",
                      width: "35%",
                      fontSize: 12,
                      fontFamily: "monospace",
                      border: "none",
                      backgroundColor: "#EEEEEE",
                    }}
                  >
                    <code>{JSON.stringify(record.meta_data, 2, 2)}</code>
                  </pre>
                </div>
              ),
              rowExpandable: (record) => Boolean(record.meta_data),
            }}
          />
        </div>
      ) : null}
    </div>
  );
};
export default BottomBar;
